// Theme registry and DOM application.
//
// `cosmic` is the default and is expressed as the *absence* of data-theme, so
// the :root block in landing.css stays the cosmic palette. Every other theme is
// a data-theme override. This matches what the pre-React page did — don't
// "simplify" it to data-theme="cosmic" or the base palette stops applying.

export const THEME_STORAGE_KEY = 'mylecture-theme';

export const THEMES = [
  { id: 'cosmic',   name: 'Cosmic',   nameHash: '4e1b51daa42646ee', desc: 'Dark, vibrant neon',        descHash: '6cb2a28200d2ebf7', swatch: ['#ff6b6b', '#ffd93d', '#6bcb77', '#4d96ff', '#c084fc'] },
  { id: 'daylight', name: 'Daylight', nameHash: '30dfa1dd5d120984', desc: 'Bright, clean, colorful',   descHash: 'bd43b8045d2e906f', swatch: ['#ef4444', '#eab308', '#22c55e', '#3b82f6', '#a855f7'] },
  { id: 'oxford',   name: 'Oxford',   nameHash: 'f3966925d3b328c7', desc: 'Dark navy, gold accents',   descHash: '3863ad4ddcfe4377', swatch: ['#c9a855', '#d4a843', '#5a9e6f', '#6b8fc4', '#9b7fc4'] },
  { id: 'ivory',    name: 'Ivory',    nameHash: 'f3adb67e9237d2bd', desc: 'Warm academic, serious',    descHash: '6798b2d802aadd7b', swatch: ['#8b2c3a', '#9e6b23', '#3d7a54', '#2d5a8e', '#6b4d8a'] },
  { id: 'slate',    name: 'Slate',    nameHash: '10ad4c3873636fa8', desc: 'Minimal, corporate clean',  descHash: '4135946e2f7b1694', swatch: ['#d14040', '#c08c20', '#2d8a50', '#2b6cb0', '#7c4dbd'] },
  { id: 'polyu',    name: 'PolyU',    nameHash: 'a5612e327b6e7fb1', desc: 'Brick red, institutional',  descHash: 'f429b20cba1ed6d6', swatch: ['#9B2335', '#A8553A', '#3D7A54', '#2B4C7E', '#6B3A5D'] },
];

const THEME_IDS = new Set(THEMES.map((t) => t.id));

export function themeName(id) {
  const found = THEMES.find((t) => t.id === id);
  return found ? found.name : 'Cosmic';
}

export function readStoredTheme() {
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY);
    if (saved && THEME_IDS.has(saved)) return saved;
  } catch {
    /* private mode / storage disabled */
  }
  return 'cosmic';
}

export function storeTheme(id) {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, id);
  } catch {
    /* nothing we can do; the theme still applies for this page view */
  }
}

export function applyThemeAttribute(id) {
  if (id === 'cosmic') {
    document.documentElement.removeAttribute('data-theme');
  } else {
    document.documentElement.setAttribute('data-theme', id);
  }
}

// The theme dot mirrors the two accent variables of the active theme. They only
// resolve once the attribute above has been applied and styles recalculated.
export function readAccentGradient() {
  const s = getComputedStyle(document.documentElement);
  const r = s.getPropertyValue('--accent-r').trim();
  const e = s.getPropertyValue('--accent-e').trim();
  return `linear-gradient(135deg, ${r}, ${e})`;
}
